import { Component, EventEmitter, Input, Output } from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import { TipoContesto, TIPO_CONTESTO} from "../../../_helpers/TipoContesto";

@Component({
    selector: 'app-select-tipo-contesto',
    templateUrl: './select-tipo-contesto.component.html',
    styleUrls: ['./select-tipo-contesto.component.scss'],
    standalone: false
})
export class SelectTipoContestoComponent {
  @Input() tipoContesto: TipoContesto;
  @Output() tipoContestoChange = new EventEmitter<TipoContesto>();
  tipoContestosItem = TIPO_CONTESTO;
  selectTipoContesto = (e: SelectCustomEvent) => this.tipoContestoChange.emit(+e.target.value);
}
